<!--
 * :Date: 2024-07-29 11:27:50
 * :Description: 
 * :Author: zq.wei
 * :LastEditors: zq.wei
 * :LastEditTime: 2024-07-29 14:50:15
-->


<template>
  <div class="oper-content">
    <el-form-item label="工厂" prop="factoryNo">
      <el-select v-model="value.factoryNo" filterable  clearable @change="changeOne" placeholder="">
        <el-option v-for="item in list1" :key="item.factoryNo" :label="item.factoryName" :value="item.factoryNo"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="运行部" prop="workshopId">
      <el-select v-model="value.workshopId" filterable clearable @change="changeTwo" placeholder="">
        <el-option v-for="item in list2" :key="item.workshopNo" :label="item.workshopName" :value="item.workshopNo"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="装置" prop="unitId">
      <el-select v-model="value.unitId" filterable clearable placeholder="">
        <el-option v-for="item in list3" :key="item.unitNo" :label="item.unitName" :value="item.unitNo"></el-option>
      </el-select>
    </el-form-item>
    <slot />
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    value: Object
  },
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: ""
      },
      list1: [],
      list2: [],
      list3: []
    };
  },
  created() {
    this.getList1();
    // 数据回写
    this.setList();
  },
  methods: {
    setList() {
      const { factoryNo, workshopId } = this.value;
      if (factoryNo || factoryNo == 0) {
        // 获取运行部列表
        const params = { type: 2, code: factoryNo };
        this.getList(params).then(data => {
          this.list2 = data;
        });
        // 获取装置列表
        const params1 = { type: 3, code: workshopId };
        this.getList(params1).then(data => {
          this.list3 = data;
        });
      }
    },
    async getList(params) {
      const res = await this.$axios.get("/tf/getAllFactoryBaseInfo", {
        params
      });
      // console.log("res", res.data.data);
      return res.data.data;
    },
    // 获取工厂列表
    async getList1() {
      const params = { type: 1 };
      const data = await this.getList(params);

      this.list1 = data;
    },
    // change  工厂
    async changeOne(factoryNo) {
      this.value.workshopId = "";
      this.value.unitId = "";
      this.list2 = [];
      this.list3 = [];
      if (factoryNo != "") {
        // 查运行部数据
        const params = { type: 2, code: factoryNo };
        const data = await this.getList(params);
        this.list2 = data;
      }
    },
    async changeTwo(workshop) {
      // this.value.workshop = "";
      this.value.unitId = "";
      // this.list2 = [];
      this.list3 = [];
      if (workshop != "") {
        // 查运行部数据
        const params = { type: 3, code: workshop };
        const data = await this.getList(params);
        this.list3 = data;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.oper-content {
  display: flex;
  flex-wrap: wrap;
  ::v-deep .el-form-item {
    width: 50%;
    .el-select {
      display: block;
    }
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/selectUnitSpan.vue